import { Person, TUpdateOrderType } from 'entities/person';
import { FC } from 'react';
import { Flex } from 'shared/ui/flex';
import { Typography } from 'shared/ui/typography';
import {
	ButtonContainer,
	HeaderNameContainer,
	MarginRightAuto,
} from './styles';
import { ModalProvider } from 'shared/ui/modal';
import { PersonModalEdit } from './personModalEdit';

interface PersonModalHeaderProps {
	person: Person | null;
	updatePersonBook?: boolean;
	updateOrder?: TUpdateOrderType;
}

export const PersonModalHeader: FC<PersonModalHeaderProps> = ({
	person,
	updatePersonBook,
	updateOrder,
}) => {
	return (
		<>
			{person && (
				<Flex $width="450px" $gap="15px" $alignItems="center">
					<ButtonContainer>
						<ModalProvider>
							<PersonModalEdit
								updatePersonBook={updatePersonBook}
								updateOrder={updateOrder}
							/>
						</ModalProvider>
					</ButtonContainer>

					<HeaderNameContainer>
						<MarginRightAuto>
							<Typography
								isBold={true}
								truncate={true}
								mode={'h2'}
							>
								{person?.name}
							</Typography>
						</MarginRightAuto>
					</HeaderNameContainer>
				</Flex>
			)}
		</>
	);
};
